<!-- 协作项目 -->
<template>
    <div class="project">
        <div class="bottom flex-between">
            <div class="item flex-column" v-for="(item,index) in imgs" :key="index" @click="goDetail(item.schoolId,item.name)">
                <img :src="item.img" alt="">
                <span>{{item.name}}</span>
            </div>
        </div>
        <div class="more flex-align-center">展开更多</div>
        <Login3 v-if="showLogin" :schoolId='schoolId' :schoolName="schoolName"></Login3>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                index: 0,
                imgs: [{
                        name: '兴安盟扎赉特旗音德尔第三中学',
                        img: require('../assets/images/school5.png'),
                        schoolId: 4164
                    },
                    {
                        name: '赤峰市巴林左旗林东第九中学',
                        img: require('../assets/images/school6.png')
                    },
                    {
                        name: '锡林郭勒盟正镶白旗第二中学',
                        img: require('../assets/images/school7.png')
                    },
                    {
                        name: '兴安盟科尔沁右翼中旗巴彦呼舒镇第三中学',
                        img: require('../assets/images/school8.png')
                    }, {
                        name: '北京十二中',
                        img: require('../assets/images/school1.jpg')
                    },
                    {
                        name: '陈经纶中学',
                        img: require('../assets/images/school2.jpg')
                    },
                    {
                        name: '大兴三中',
                        img: require('../assets/images/school3.jpg')
                    },
                    {
                        name: '北京市第一O一中学',
                        img: require('../assets/images/school4.jpg')
                    },
                    {
                        name: '北京十二中',
                        img: require('../assets/images/school1.jpg')
                    },
                    {
                        name: '陈经纶中学',
                        img: require('../assets/images/school2.jpg')
                    },
                    {
                        name: '大兴三中',
                        img: require('../assets/images/school3.jpg')
                    },
                    {
                        name: '北京市第一O一中学',
                        img: require('../assets/images/school4.jpg')
                    },
                    {
                        name: '兴安盟扎赉特旗音德尔第三中学',
                        img: require('../assets/images/school5.png')
                    },
                    {
                        name: '赤峰市巴林左旗林东第九中学',
                        img: require('../assets/images/school6.png')
                    },
                    {
                        name: '锡林郭勒盟正镶白旗第二中学',
                        img: require('../assets/images/school7.png')
                    },
                    {
                        name: '兴安盟科尔沁右翼中旗巴彦呼舒镇第三中学',
                        img: require('../assets/images/school8.png')
                    }, {
                        name: '锡林郭勒盟正镶白旗第二中学',
                        img: require('../assets/images/school7.png')
                    },
                    {
                        name: '兴安盟科尔沁右翼中旗巴彦呼舒镇第三中学',
                        img: require('../assets/images/school8.png')
                    },
                ],
                showLogin: false,
                schoolId:null,
                schoolName:null
            }
        },
        methods: {
            goDetail(schoolId,schoolName) {
                console.log('schoolId:', schoolId);
                // this.schoolId = schoolId;
                // this.schoolName = schoolName;
                // this.showLogin = true;
                // this.$store.commit('isDisplayLogin', true);
            },
        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    .project {
        width: 1200px;
        margin: 50px auto;

        .top {
            width: 1200px;
            height: 120px;
            background: #FFFFFF;
            box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
            box-sizing: border-box;
            padding: 23px 38px;

            .address {
                font-size: 16px;
                color: #353535;

                span {
                    color: #999999;
                    margin-left: 44px;
                }

                .actived {
                    color: #3B73FE;
                }
            }

            .line {
                width: 100%;
                height: 1px;
                border-bottom: 1px dashed #DDDDDD;
            }
        }

        .bottom {
            margin-top: 30px;
            flex-wrap: wrap;

            .item {
                align-items: center;
                margin-bottom: 30px;
                width: 386px;
                height: 369px;
                background: #FFFFFF;
                box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);

                img {
                    width: 100%;
                    height: 275px;
                }

                span {
                    display: block;
                    margin-top: 34px;
                    color: #333333;
                    font-size: 22px;
                }
            }
        }

        .more {
            margin: 50px auto;
            width: 219px;
            height: 50px;
            background: linear-gradient(0deg, #1262E7 0%, #4285F4 100%);
            font-size: 16px;
            color: #fff;
            border-radius: 30px;
        }
    }
</style>